/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import jobStyles from "./jobStyles";
import SendApplication from "./SendApplication";
import TextContainer from "../../Container/TextContainer";
import { Helmet } from "react-helmet-async";
import Layout from "../../../containers/Layouts/Layout";
import Typography from "@mui/material/Typography";
import HeadlineSection from "../../Sections/Generic/HeadlineSection/HeadlineSection";
import cvImage from "../../../assets/img/jobs/cv.svg";
import MuiListNativeStyled from "../../List/MuiListNativeStyled";
import { gaSet } from "../../../services/googleAnalyticsService";

const BusinessLawyer = () => {
  const title = "Jobs - Wirtschaftsjuristin / Wirtschaftsjurist (m/w/d) | Legalbird";

  gaSet({ title: title });

  return (
    <Layout backgroundType={"landingpage"}>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <HeadlineSection headline={"Wirtschaftsjuristin / Wirtschaftsjurist (m/w/d)"} image={cvImage} />
      <TextContainer sx={jobStyles.container}>
        <Typography variant={"h4"} sx={{
          textAlign: "center"
        }}>
          Warum eine Legal-Tech-Kanzlei dein nächster Karriereschritt sein sollte!
        </Typography>
        <Typography sx={{
          marginBottom: "16px"
        }}>
          Du hast dein juristisches Studium mit dem ersten Staatsexamen oder mit dem Master in Wirtschaftsrecht abgeschlossen und suchst einen Einstieg, der
          dich von Anfang an begeistert?
        </Typography>
        <Typography sx={{
          marginBottom: "16px"
        }}>Du möchtest juristisch arbeiten, ohne in einer klassischen Kanzleistruktur festzustecken?</Typography>
        <Typography sx={{
          marginBottom: "16px"
        }}>
          Dann komm zu uns und werde Teil einer <strong>Legal-Tech-Kanzlei im Verbraucherrecht!</strong>
        </Typography>
        <Typography sx={{
          marginBottom: "16px"
        }}>
          Das Verbraucherrecht ist ein dynamisches und praxisnahes Rechtsgebiet. Durch wiederkehrende Fragestellungen und eine hohe Fallzahl kannst du nicht nur
          tief in die Materie einsteigen, sondern auch an der Entwicklung effizienter Lösungen und Strategien mitwirken. Als Wirtschafts-/DiplomjuristIn bist du
          dabei ein wichtiger Teil unseres juristischen Teams und unterstützt aktiv die anwaltliche Fallbearbeitung.
        </Typography>
        <Typography variant={"h4"} sx={{ marginTop: "6px" }}>
          Deine Aufgaben bei uns
        </Typography>
        <MuiListNativeStyled
          sx={jobStyles.list}
          listItems={[
            "Unterstützung der Rechtsanwältinnen bei der Bearbeitung von Mandaten",
            "Juristische Recherche und Aufbereitung von rechtlichen Fragestellungen",
            "Mitarbeit an Fällen aus dem Vertragsrecht, allgemeinen Zivilrecht, Mietrecht und Arbeitsrecht",
            "Prüfung von Verträgen, Schriftsätzen und rechtlichen Sachverhalten",
            "Mitwirkung an der Weiterentwicklung standardisierter Abläufe und Legal-Tech-Prozesse",
          ]}
        />
        <Typography variant={"h4"} sx={{ marginTop: "6px" }}>
          Wen wir suchen
        </Typography>
        <MuiListNativeStyled
          sx={jobStyles.list}
          listItems={[
            "Du hast ein abgeschlossenes Studium als Wirtschaftsjurist (LL.B./LL.M.) oder als Diplomjurist",
            "Du bringst Interesse an praktischer juristischer Arbeit im Verbraucherrecht mit",
            "Du arbeitest sorgfältig, strukturiert und lösungsorientiert ",
            "Du bist offen für neue Technologien und digitale Arbeitsweisen",
            "Berufserfahrung ist willkommen, aber kein Muss – auch Berufseinsteiger sind bei uns ausdrücklich willkommen.",
          ]}
        />
        <Typography variant={"h4"} sx={{ marginTop: "6px" }}>
          Was uns von klassischen Kanzleien unterscheidet
        </Typography>
        <MuiListNativeStyled
          sx={jobStyles.list}
          listItems={[
            "Wir Duzen uns! Und das von Anfang an - und nicht erst seit eine Karriereberatung es uns empfohlen hat.",
            "Wir bieten flexible Arbeitszeit! Du möchtest morgens später anfangen oder deine Mittagspause verlängern? Kein Problem!",
            "Mobiles Arbeiten! Heute im Büro, aber morgen lieber von Zuhause? Du weißt, wo du dich am besten konzentrieren kannst!",
            "Ein junges dynamisches Team! ",
            "Kollegialer Austausch! Ganz wie es dir passt, kannst du dich mit deinen KollegInnen unterhalten oder auch mal während der Arbeit Musik hören.",
            "Echte Benefits! Bei uns erhältst du nicht nur eine überdurchschnittliche Bezahlung, sondern auch ein Deutschlandticket sowie eine Urban-Sports-Mitgliedschaft bezuschusst.",
            "Eigene Legal-Tech Software! Wir haben unsere eigene IT! Nur so ist der Austausch gewährleistet und das Programm zum Bearbeiten von Mandaten wird täglich an unsere Anforderungen angepasst",
          ]}
        />
        <Typography sx={{
          marginBottom: "16px"
        }}>
          <strong>Du findest das alles spannend?</strong>
        </Typography>
        <Typography sx={{
          marginBottom: "16px"
        }}>
          Wir bieten dir die Möglichkeit, Teil einer innovativen und wachsenden Legal-Tech-Branche zu sein und juristische Arbeit modern, effizient und
          praxisnah kennenzulernen. Wenn dich ein kollegiales Umfeld, sinnstiftende juristische Arbeit und eine gesunde Work-Life-Balance ansprechen, freuen wir
          uns auf deine Nachricht!
        </Typography>
        <Typography sx={{
          marginBottom: "16px"
        }}>
          Du hast noch Fragen oder bist dir unsicher, ob Legal-Tech zu dir passt? Melde dich gerne – wir sind überzeugt:{" "}
          <strong>Alles, was du brauchst, kannst du bei uns lernen.</strong>
        </Typography>
      </TextContainer>
      <SendApplication />
    </Layout>
  );
};

export default BusinessLawyer;
